var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-page-container"},[_c('div',{staticClass:"offers-header"},[_c('img',{attrs:{"src":("/images/triangle/triRewards_logo_" + (this.language) + ".png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }